import { milliseconds } from 'utils/milliseconds';
export var defaultOptions = {
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: milliseconds.inSeconds(30)
};
